import { gql } from '@apollo/client';

export const FETCH_CALPUFF_CONFIGURATIONS = gql`
    query fetchCalpuffConfigurations($filter: GuidIdInFilter) {
        facility {
            models {
                configurations {
                    calpuff(filter: $filter) {
                        id
                        name
                        description
                        settings
                        linkedCalmetConfigurations {
                            id
                            name
                        }
                        pollutants {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;
